<nav class="navbar navbar-expand-lg navbar-light bg-white">
  <div class="container">

    <!-- Brand Logo -->
    <a class="navbar-brand logo" routerLink="/" routerLinkActive="active" ariaCurrentWhenActive="page">
      <img [src]="logoImageURL"/>
    </a>

    <!-- Centered search bar -->
    <div class="navbar-center" *ngIf="showSearchBar">
      <custom-search-bar></custom-search-bar>
    </div>

    <!-- Toggler for mobile view -->
    <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
            aria-controls="offcanvasExample" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Desktop only Navbar content -->
    <div class="collapse navbar-collapse align-items-center flex-grow-0" id="navbarSupportedContent">

      <!-- Right side links, separator, button, and link -->
      <ul class="navbar-nav mb-2 mb-lg-0 align-items-center">
        <li class="nav-item">
          <a class="nav-link" routerLink="/faqs" routerLinkActive="active" i18n="@@faqsTitle">FAQs</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/about" routerLinkActive="active" i18n="@@aboutUsTitle">About</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/contact-us" routerLinkActive="active" i18n="@@contactUsTitle">Contact</a>
        </li>
        <!-- Vertical separator for larger screens, horizontal for smaller screens -->
        <li class="nav-item d-flex align-items-center custom-separator">
          <div></div>
        </li>
        <!-- Link before the button -->
        <li class="nav-item" *ngIf="showLoginButtons">
          <a class="nav-link"
             routerLink="/login"
             [state]="getLoginRoute()"
             (click)="onLoginClick()"
             routerLinkActive="active" i18n="@@loginTitle">login</a>
        </li>
        <!-- Button -->
        <li class="nav-item" *ngIf="showLoginButtons">
          <button class="button-primary" [routerLink]="getSignUpRoute()" routerLinkActive="active" i18n="@@signUpTitle">
            Sign up
          </button>
        </li>
        <!-- User Account -->
        <li class="nav-item" *ngIf="userLoggedIn || customerLoggedIn">
          <div class="dropdown">
            <button class="account-div dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ getUsername() }} <i class="bi bi-chevron-down"></i>
            </button>
            <ul class="dropdown-menu">
              <li *ngIf="isUserMerchant()">
                <a class="dropdown-item" (click)="goToMerchantPortal()" i18n="@@goToPortal">
                  Go to Portal
                </a>
              </li>
              <li *ngIf="isCustomerLoggedIn()">
                <div class="customer-logged-in-container" routerLink="/profile">
                  <img src="assets/account-icon.svg">
                  <p i18n="@@myAccount">My Account</p>
                </div>
              </li>
              <li class="m-2">
                <hr class="dropdown-divider">
              </li>
              <!--              <li><a class="dropdown-item" href="#">Another action</a></li>-->
              <li>
                <div class="customer-logged-in-container" *ngIf="userLoggedIn || customerLoggedIn" (click)="logout()">
                  <img src="assets/logout-icon.svg">
                  <p i18n="@@logoutTitle">Logout</p>
                </div>
              </li>
            </ul>
          </div>
        </li>
        <!-- Link before the button -->
        <li class="nav-item">
          <a class="nav-link" routerLink="/merchants" routerLinkActive="active" *ngIf="showHaveARestaurantButton"
             i18n="@@haveARestaurantTitle">Have a restaurant?</a>
        </li>
        <!-- Link beside button -->
        <li class="nav-item">
          <a class="nav-link language-link" href="{{ switchLanguageURL }}"><img
            src="{{ switchLanguageImageURL }}"/> {{ switchLanguageName }}</a>
        </li>
      </ul>
    </div>
  </div>
</nav>


<!-- Mobile view Navbar content -->
<div class="offcanvas offcanvas-top h-auto" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
  <div class="container">
    <div class="offcanvas-header">
      <div class="menu-title"><p>Menu</p></div>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <primary-button
        *ngIf="showLoginButtons"
        borderRadius="{{'8px'}}"
        title="Sign up"
        [routerLink]="getSignUpRoute()"
        data-bs-dismiss="offcanvas">
      </primary-button>
      <div *ngIf="showLoginButtons"
           class="login-button"
           routerLink="/login"
           [state]="getLoginRoute()"
           data-bs-dismiss="offcanvas">
        Login
      </div>
      <div class="menu-item" *ngIf="userLoggedIn && isUserMerchant()" data-bs-dismiss="offcanvas"
           (click)="goToMerchantPortal()">
        <img src="assets/account-icon.svg">
        <p i18n="@@goToPortal">Go to Portal</p>
      </div>
      <div class="menu-item" routerLink="/faqs" data-bs-dismiss="offcanvas">
        <img src="assets/faqs-icon.svg">
        <p i18n="@@faqsTitle">FAQs</p>
      </div>
      <div class="menu-item" routerLink="/about" data-bs-dismiss="offcanvas">
        <img src="assets/about-us-icon.svg">
        <p i18n="@@aboutUsTitle">About</p>
      </div>
      <div class="menu-item" routerLink="/contact-us" data-bs-dismiss="offcanvas">
        <img src="assets/contact-us-icon.svg">
        <p i18n="@@contactUsTitle">Contact</p>
      </div>
      <div class="language-item" data-bs-dismiss="offcanvas">
        <a class="nav-link" href="{{ switchLanguageURL }}">
          <div class="language-title">
            <img src="assets/language-icon.svg">
            <p i18n="@@language">Language</p>
          </div>
          <div>
            <img src="{{ switchLanguageImageURL }}"/> {{ switchLanguageName }}
          </div>
        </a>
      </div>
      <hr class="border-bottom border-1" *ngIf="showHaveARestaurantButton">
      <div class="menu-item" routerLink="/merchants" data-bs-dismiss="offcanvas" *ngIf="showHaveARestaurantButton">
        <img src="assets/restraunt-menu-icon.svg">
        <p i18n="@@haveARestaurantTitle">Have a restaurant?</p>
      </div>
      <hr class="border-bottom border-1" *ngIf="userLoggedIn" data-bs-dismiss="offcanvas">
      <div class="logout-button" *ngIf="userLoggedIn || customerLoggedIn" (click)="logout()">
        <img src="assets/logout-icon.svg">
        <p i18n="@@logoutTitle">Logout</p>
      </div>
    </div>
  </div>
</div>
